import { memo } from 'react';

import ExpertSessionIconSVG from '@/assets/expert-session-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IExpertSessionIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ExpertSessionIconSVG} {...props} />
);

export const ExpertSessionIcon = memo(IExpertSessionIcon) as typeof IExpertSessionIcon;
